import { NgModule } from '@angular/core';
import { TextSearchPipe } from './text-search/text-search';
@NgModule({
	declarations: [TextSearchPipe],
	imports: [],
	exports: [TextSearchPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts